export default {
  server : {
    graphql : 'https://new-api.delikateska.ru',
    rest : 'https://new-api.delikateska.ru',
    api : 'https://api.delikateska.ru/graphql/'
  }
}
